import { createContext, useState, useEffect } from 'react';

export const AccountsContext = createContext();

export const AccountsProvider = ({ children }) => {
    const [accountId, setAccountId] = useState(() => {
        return localStorage.getItem('accountId') || null; 
    });

    const [attributes, setAttributes] = useState(() => {
        const storedAttributes = localStorage.getItem('accountAttributes');
        return storedAttributes ? JSON.parse(storedAttributes) : null; // Parse JSON from localStorage
    });

    useEffect(() => {
        if (accountId) {
            localStorage.setItem('accountId', accountId); // Persist accountId to localStorage
        } else {
            localStorage.removeItem('accountId'); // Clear if no accountId
        }
    }, [accountId]);

    useEffect(() => {
        if (attributes) {
            localStorage.setItem('accountAttributes', JSON.stringify(attributes)); // Persist attributes to localStorage
        } else {
            localStorage.removeItem('accountAttributes'); // Clear if no attributes
        }
    }, [attributes]);

    return (
        <AccountsContext.Provider value={{ accountId, setAccountId, attributes, setAttributes }}>
            {children}
        </AccountsContext.Provider>
    );
};